import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column mt-2 mb-3 w-100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column text-primary text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check animated flash infinite mb-2 font-size-base" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Checking selected dates against Patient's frequency...", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Error", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-3" }, " There was a problem while checking selected dates against Patient's frequency. Please try again. ", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createCommentVNode(" <small>\r\n                    If the problem persists, click <report-error-link>here</report-error-link> to report it.\r\n                </small> ")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "d-flex mb-2 font-size-xl" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Task:", -1 /* HOISTED */)
const _hoisted_11 = { class: "ms-1 me-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Discipline:", -1 /* HOISTED */)
const _hoisted_13 = { class: "ms-1 me-2" }
const _hoisted_14 = { class: "table table-responsive-md border border-gray mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Selected Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Frequency")
  ])
], -1 /* HOISTED */)
const _hoisted_16 = { class: "${frequency ? 'text-success' : 'text-danger'}" }
const _hoisted_17 = {
  key: 0,
  class: "ms-1 fas fa-check-circle text-success"
}
const _hoisted_18 = {
  key: 1,
  class: "ms-1 fas fa-exclamation-triangle text-danger"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "${frequency}", -1 /* HOISTED */)
const _hoisted_20 = {
  key: 1,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoading && !_ctx.isError)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
      : _createCommentVNode("v-if", true),
    (_ctx.isError && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkFrequencyCompliance()))
          }, "Try Again"),
          _hoisted_8
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (!_ctx.isLoading && !_ctx.isError && _ctx.availableFrequencies.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("section", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedTask.name), 1 /* TEXT */),
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.disciplineName), 1 /* TEXT */)
          ]),
          _createElementVNode("table", _hoisted_14, [
            _hoisted_15,
            _createCommentVNode(" LIST "),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFrequencies, (item) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.formatDate(item.visitDate)), 1 /* TEXT */),
                    (item.frequency)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                      : (_openBlock(), _createElementBlock("i", _hoisted_18))
                  ]),
                  _createElementVNode("td", null, [
                    (item.frequency)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_19,
                          _createTextVNode(" (" + _toDisplayString(_ctx.formatDate(item.startDate)) + " - " + _toDisplayString(_ctx.formatDate(item.endDate)) + ") ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock("strong", _hoisted_20, "Outside Frequency"))
                  ]),
                  _createCommentVNode(" <td class=\"text-end\">\r\n                            <button class=\"btn table-btn btn-outline-danger btn-xs\"\r\n                                @click=\"deleteVisitDate(visitDate)\" v-if=\"!frequency\">\r\n                                Delete\r\n                            </button>\r\n                            <i class=\"text-default\" v-else>Within Frequency</i>\r\n                        </td> ")
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}